module.exports = __webpack_public_path__ + "img/11.997b8bbc.png";